import React, { useContext } from "react";
import classes from "./ProjectItem2.module.css";
import { RiGithubLine } from "react-icons/ri";
import { RiExternalLinkLine } from "react-icons/ri";
import { ThemeContext } from "../../../ThemeProvider";
import Reveal from "react-awesome-reveal";
import { keyframes } from "@emotion/react";

const customAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const ProjectItem = ({ item }) => {
  const { img, name, desc, tech, code, demo } = item;

  const { dark } = useContext(ThemeContext);

  return (
    <Reveal
      keyframes={customAnimation}
      triggerOnce="true"
      duration={1000}
      fraction={0.2}
    >
      <div
        className={
          dark
            ? `${classes.project_details} ${classes.project_details_dark}`
            : classes.project_details
        }
      >
        <div
          className={
            dark
              ? `${classes.details} ${classes.details__dark}`
              : classes.details
          }
        >
          <a href={demo} target="_blank">
            <h2>{name}</h2>
          </a>
          <p
            className={
              dark ? `${classes.desc} ${classes.desc__dark}` : classes.desc
            }
          >
            {desc}
          </p>
          <div
            className={
              dark
                ? `${classes.tech_stack} ${classes.tech_stack_dark}`
                : classes.tech_stack
            }
          >
            {tech?.map((t) => (
              <p key={t}>{t}</p>
            ))}
          </div>
          <div
            className={
              dark ? `${classes.links} ${classes.links__dark}` : classes.links
            }
          >
            <p>
              <a href={code} target="_blank">
                <RiGithubLine />
              </a>
            </p>
            <p>
              {" "}
              <a href={demo} target="_blank">
                <RiExternalLinkLine />
              </a>
            </p>
          </div>
        </div>
        <a className={classes.image__container} href={demo} target="_blank">
          <img
            src={img}
            alt="netflix-clone"
            className={
              dark ? `${classes.image} ${classes.image__dark}` : classes.image
            }
          />
        </a>
      </div>
    </Reveal>
  );
};

export default ProjectItem;
